import { getPlatform } from '@scaleaq/scaleui/utility/helpers/getPlatform';

import type { HotkeyBase, ModifierType } from './hotkeys/types.ts';

export const isMac: boolean = typeof window !== 'undefined' && getPlatform() === 'MacOS';

/** Modifier as the user sees it on this platform: `Meta` is Cmd on macOS and Ctrl elsewhere. */
export const getDisplayModifier = (modifierType?: ModifierType): ModifierType | undefined => {
  if (modifierType === 'Alt' && isMac) {
    return 'Option';
  }
  if (modifierType === 'Meta') {
    return isMac ? 'Cmd' : 'Ctrl';
  }
  return modifierType;
};

/**
 * Keycap text for a hotkey, e.g. `Shift+K`. Derived from the definition that also does the
 * matching, so a label can never drift from the key it names. Not translated: these are key
 * names, so call sites pass it through `asNonI18n` or an interpolated `t(...)` value.
 */
export const formatHotkeyLabel = ({
  hotkeyModifier,
  secondaryHotkeyModifier,
  primary,
}: Pick<HotkeyBase, 'hotkeyModifier' | 'secondaryHotkeyModifier' | 'primary'>): string =>
  [
    getDisplayModifier(hotkeyModifier?.modifier),
    getDisplayModifier(secondaryHotkeyModifier?.modifier),
    primary.keyboardKey,
  ]
    .filter(Boolean)
    .join('+');
